module.exports = __webpack_public_path__ + "456b4c449db336a6536dd51bb24560a9.svg";